export default {
  status_compliant: "Zgodne",
  status_compliant_location: "Zgodne z zastrzeżeniem ryzyka lokalizacji/obieku",
  status_not_compliant: "Niezgodne",
  status_rejected: "Nieocenione - poza zakresem",
  status_insufficent: "Nieocenione - niewystarczające informacje",
  status_conditional: "Warunkowo zgodne",
  status_draft: "Kopia robocza",
  status_saved: "Wysłane do weryfikacji",
  status_not_reviewed: "Oczekuje na weryfikację",
  status_not_reviewed_late: "Zgłoszone po terminie",
  status_moderation: "W trakcie weryfikacji",
  status_closed: "Ocena zakończona",
  status_deleted: "Usunięte",
  status_none: "Brak oceny",
  status_any: "Dowolny status",
  status_corrective: "Działania korygujące",
  status_edit: "Wymagana edycja",
  status_null: "",
  status_unknown: "Nie wszystkie pytania zostały ocenione",

  status_evaluation_moderation: "pozostaw w moderacji, bez oceny",
  status_evaluation_compliant: "zgodne i zakończ weryfikację",
  status_evaluation_compliant_location:
    "zgodne z zastrzeżeniem ryzyka lokalizacji/obieku i zakończ weryfikację",
  status_evaluation_corrective:
    "działania korygujące i wyślij do edycji przez zgłaszającego",
  status_evaluation_conditional: "warunkowo zgodne i zakończ weryfikację ",
  status_evaluation_not_compliant: "niezgodne i zakończ weryfikację",
  status_evaluation_rejected: "poza zakresem  i zakończ weryfikację",
  status_evaluation_insufficent:
    "niewystarczające informacje  i zakończ weryfikację",
  status_evaluation_none: "brak oceny  i zakończ weryfikację",

  criteria_meta: "Informacje ogólne o wydarzeniu",
  criteria_general: "Informacje ogólne o wydarzeniu",
  criteria_location: "Lokalizacja i obiekt",
  criteria_programme: "Program wydarzenia",
  criteria_hospitality: "Goście/osoby towarzyszące",
  criteria_accommodation: "Pakiet rejestracyjny/zakwaterowanie",
  criteria_communication: "Materiały konferencyjne/komunikacja",

  organiser_logistic: "logistycznym",
  organiser_essential: "merytorycznym",
  organiser_both: "merytorycznym i logistycznym",
  organiser_none: "żadnym z powyższych",

  editions_once: "wydarzenie jednorazowe",
  editions_first_time: "wydarzenie odbywa się po raz pierwszy",
  editions_first_time_help: "organizator planuje kolejne edycje",
  editions_3_or_less: "odbyły się nie więcej niż 3 edycje wydarzenia",
  editions_4_or_more: "odbyły się więcej niż 3 edycje wydarzenia",

  event_type_practice:
    "praktyczne szkolenie z procedur w środowisku klinicznym",
  event_type_practice_help: `<p>Specyficzny typ wydarzenia edukacyjnego, organizowanego w środowisku klinicznym, którego celem jest praktyczna nauka danej procedury medycznej.</p><p>UWAGA: Takie wydarzenie musi spełniać dodatkowe kryteria odnośnie programu i formuły. Zapoznaj się z <a href="${process.env.VUE_APP_PUBLIC_URL}sowe/szkolenia-z-procedur/" target="_blank">Kryteriami Oceny Wydarzeń</a>.</p>`,
  event_type_educational:
    "wydarzenie edukacyjne (kongres, konferencja, sympozjum, warsztat, kurs, workshop)",

  audience_50_or_less: "mniej niż 50 uczestników",
  audience_50_199: "50-199 uczestników",
  audience_200_499: "200-499 uczestników",
  audience_500_999: "500-999 uczestników",
  audience_1000_1999: "1000-1999 uczestników",
  audience_2000_or_more: "powyżej 2000 uczestników",

  range_national: "ogólnokrajowy",
  range_national_help:
    "Wydarzenie, którego nie można zakwalifikować jako wydarzenia o zasięgu regionalnym, wydarzenia o zasięgu wojewódzkim, bądź wydarzenia o zasięgu lokalnym.",
  range_regional: "regionalny",
  range_regional_help:
    "Wydarzenie, którego wszyscy uczestnicy (pasywni) będący HCP wykonują zawód w ramach więcej niż jednego województwa i mniej niż 4 województw.",

  range_voivodeship: "wojewódzki",
  range_voivodeship_help:
    "Wydarzenie, którego wszyscy uczestnicy (pasywni) będący HCP wykonują zawód w ramach jednego województwa oraz nie będące zarazem wydarzeniem o zasięgu lokalnym.",

  range_local: "lokalny",
  range_local_help:
    "Wydarzenie, którego wszyscy uczestnicy (pasywni) będący HCP wykonują zawód w ramach jednego miasta lub powiatu.",

  region_dolnoslaskie: "dolnośląskie",
  region_kujawskopomorskie: "kujawsko - pomorskie",
  region_lubelskie: "lubelskie",
  region_lubuskie: "lubuskie",
  region_lodzkie: "łódzkie",
  region_malopolskie: "małopolskie",
  region_mazowieckie: "mazowieckie",
  region_opolskie: "opolskie",
  region_podkarpackie: "podkarpackie",
  region_podlaskie: "podlaskie",
  region_pomorskie: "pomorskie",
  region_slaskie: "śląskie",
  region_swietokrzyskie: "świętokrzyskie",
  region_warminskomazurskie: "warmińsko - mazurskie",
  region_wielkopolskie: "wielkopolskie",
  region_zachodniopomorskie: "zachodniopomorskie",

  file_type_programme: "Program wydarzenia",
  file_type_brief: "Program ramowy",
  file_type_hospitality: "Program niemerytoryczny",
  file_type_other: "Inne",

  location_type_conference: "centrum konferencyjne",
  location_type_hotel_1: "hotel z zapleczem konferencyjnym",
  location_type_hotel_2: "hotel bez zaplecza konferencyjnego",
  location_type_university: "uniwersytet",
  location_type_hospital: "szpital / klinika / oddział",
  location_type_lab: "laboratorium kliniczne / kadawerowe / weterynaryjne",
  location_type_ship: "statek wycieczkowy",
  location_type_other: "inne",
  location_type_museum: "obiekt muzealny",
  location_type_historical: "obiekt historyczny (zamek/pałac)",
  location_type_cultural:
    "obiekt kulturalny (sala koncertowa/teatr/kino/stadion)",
  location_type_restaurant: "restauracja",
  location_type_lab2: "laboratoria weterynaryjne",
  location_type_cadaver: "centra kadawerowe",
  location_type_lab3: "laboratoria kliniczne",

  feature_casino: "kasyno",
  feature_beach: "prywatną plażę / marinę / dostęp do jeziora",
  feature_golf: "pole golfowe",
  feature_spa: "SPA",
  feature_gym: "zaplecze sportowe (siłownia, basen itp.)",
  feature_ski: "wyciąg/stok narciarski",
  feature_pool: "baseny termalne/park wodny",
  feature_gym2: "rozbudowane zaplecze sportowe/boiska/korty tenisowe",
  feature_other: "inne atrakcje",
  feature_none: "nie dotyczy",

  event_area_md: "MD (wyroby medyczne)",
  event_area_ivd: "IVD (wyroby medyczne do diagnostyki in vitro)",
  event_area_both: "obu powyższych",
  event_area_none: "żadne z powyższych"
};
